import "./AssetInspectionModalImages.scss"
import IconPlus from "assets/img/icon-plus.svg?react"

import { FC, useState } from "react"
import { useTranslation } from "react-i18next"

import AddPicturesModal, { IFileToAdd } from "components/AddPicturesModal/AddPicturesModal"
import { Flex } from "components/Flex"

interface IAssetInspectionModalImageEditorProps {
    files: IFileToAdd[]
    tags: string[]
    fixedTags: string[]
    onChange(files: IFileToAdd[], tags: string[]): void
}

const AssetInspectionModalImageEditor: FC<IAssetInspectionModalImageEditorProps> = ({
    files,
    tags,
    fixedTags,
    onChange,
}) => {
    const { t } = useTranslation()
    const [addPicturesModalActiveIndex, setAddPicturesModalActiveIndex] = useState<number | null>(null)

    return (
        <>
            <Flex alignItems="center" wrap="wrap" gap="1rem">
                {files.map((file, index) => (
                    <div key={index} className="asset-inspection-modal-images__thumb">
                        <button
                            type="button"
                            className="asset-inspection-modal-images__thumb-btn"
                            data-testid="thumb-btn"
                            onClick={() => setAddPicturesModalActiveIndex(index)} />
                        <img
                            src={file.preview}
                            className="asset-inspection-modal-images__thumb-img"
                            data-testid="thumb-img"
                            alt="" />
                    </div>
                ))}
                <button
                    type="button"
                    className="asset-inspection-modal-images__add-btn"
                    aria-label={t('addPictures.choosePicture')}
                    onClick={() => setAddPicturesModalActiveIndex(0)}>
                    <IconPlus />
                </button>
            </Flex>
            {addPicturesModalActiveIndex !== null &&
                <AddPicturesModal
                    selectedFiles={files}
                    tags={tags}
                    fixedTags={fixedTags}
                    activeIndex={addPicturesModalActiveIndex}
                    onSave={onChange}
                    onClose={() => setAddPicturesModalActiveIndex(null)}
                />
            }
        </>
    )
}

export default AssetInspectionModalImageEditor
